import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './CloseButton.module.scss';

interface CloseButtonProps extends Omit<ButtonProps, 'children'> {
    withImage?: boolean;
}

const CloseButton: React.FC<CloseButtonProps> = ({ withImage = true, ...props }) => {
    return (
        <Button
          variant="text"
          className={withImage ? styles.backButton : styles.backButtonWithoutImage}
          {...props}
        >
          <CloseIcon color="action" />
        </Button>
      );
};

export default CloseButton;
